import { render, staticRenderFns } from "./FoldContainer.vue?vue&type=template&id=0aa18f66&scoped=true"
import script from "./FoldContainer.vue?vue&type=script&lang=js"
export * from "./FoldContainer.vue?vue&type=script&lang=js"
import style0 from "./FoldContainer.vue?vue&type=style&index=0&id=0aa18f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa18f66",
  null
  
)

export default component.exports